import React from 'react';
import ComingSoon from '../../Components/comingSoon';

function ProblemSolvingProjects() {
  return <ComingSoon />;
}

export default ProblemSolvingProjects; 